<template>
<div class="popup" v-if="proDialogShow" v-cloak>
    <div id="properties" class="content">
        <div class="title">
            <span>{{$t('language.common.properties')}}</span>
            <div class="icon white-close dialog-close" @click="proDialogShow=false"></div>
        </div>
        <div class="properties-cont">
            <el-tabs v-model="activeName">
                <el-tab-pane :label=general name="first">
                    <div class="general-content">
                        <div class="general-item">{{$t('language.popup.addCloudPopup.cloudName')}}: {{cloud.name}}</div>
                        <div class="general-item">{{$t('language.popup.addCloudPopup.cloudType')}}: {{$t('language.addCloud.'+cloudName)}}</div>
                        <div class="general-item">{{$t('language.popup.addCloudPopup.addedTime')}}: {{cloud.driveInfo.createTime|transferTime}}</div>
                        <div class="general-item" v-if="driveType!='googlePhotosV2'">{{$t('language.popup.addCloudPopup.userName')}}: {{userName}}</div>
                        <div class="general-item" v-if="driveType=='googlePhotosV2'">Google Photos Account: {{userName}}</div>
                        <div class="general-item" v-if="usedSpace&&(driveType!='iCloudPhotos' && driveType!='iCloudDrive')">{{$t('language.popup.addCloudPopup.usedSpace')}}: {{usedSpace|formatByte}}</div>
                        <div class="general-item" v-if="totalSpace&&(driveType!='iCloudPhotos' && driveType!='iCloudDrive')">{{$t('language.popup.addCloudPopup.totalSpace')}}: {{totalSpace|formatByte}}</div>
                        <div class="general-item" v-if="usedSpace&&driveType=='iCloudPhotos'">{{$t('language.popup.addCloudPopup.iCloudUsedSpace')}}: {{usedSpace|formatByte}}</div>
                        <div class="general-item" v-if="totalSpace&&driveType=='iCloudPhotos'">{{$t('language.popup.addCloudPopup.iCloudTotalSpace')}}: {{totalSpace|formatByte}}</div>
                        <div class="general-item" v-if="usedSpace&&driveType=='iCloudDrive'">{{$t('language.popup.addCloudPopup.iCloudDriveUsedSpace')}}: {{usedSpace|formatByte}}</div>
                        <div class="general-item" v-if="totalSpace&&driveType=='iCloudDrive'">{{$t('language.popup.addCloudPopup.iCloudDriveTotalSpace')}}: {{totalSpace|formatByte}}</div>
                    </div>
                </el-tab-pane>
                
                <el-tab-pane :label=tips name="second" v-if='!unTips.includes(cloudName)&&!emailClouds.includes(cloudName)&&driveType!="Icedrive"'>
                     <div class="tip-content" v-if="driveType!='NAS'"  v-html="$t('language.popup.addCloudPopup.'+cloudName+'Tips')">
                     </div>
                     <div class="tip-content" v-if="driveType=='NAS'"  v-html="$t('language.popup.addCloudPopup.FTPTips')">
                     </div>
                </el-tab-pane>
                <el-tab-pane :label=tips name="second" v-if='cloudName=="iCloudPhotos" || cloudName=="iCloudDrive"'>
                     <div class="tip-content" v-html="$t('language.popup.addCloudPopup.iCloudPhotosTips')">
                     </div>
                </el-tab-pane>
                <el-tab-pane :label=tips name="second" v-if='cloudName=="fourShared"'>
                     <div class="tip-content" v-html="$t('language.popup.addCloudPopup.fourSharedTips')">
                     </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
export default {
    props: ['cloudName', 'cloudId', 'cloud'],
    data: function () {
        return {
            proDialogShow: false,
            activeName: "first",
            general: this.$t('language.popup.general'),
            tips: this.$t('language.popup.tips'),
            unTips:[],
            emailClouds: [],
            userName: null,
            driveType:null,
            usedSpace:0,
            totalSpace:0,
        }
    },
    created(){
        this.unTips = commonstate.unTips;
        this.emailClouds = commonstate.emailClouds;
    }

}
</script>

<style>
.general-content {
    margin-top: 5px;
    /*no*/
}

.general-item {
    width: 100%;
    height: 43px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
    float: left;
    line-height: 40px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#properties {
    width: 500px;
    /*no*/
    height: 400px;
    /*no*/
}

.properties-cont {
    width: 100%;
    height: 355px;
    /*no*/
    box-sizing: border-box;
    padding: 0px 20px 0px 20px;
    /*no*/
}

.el-tabs__nav-scroll {
    height: 45px;
    /*no*/
}

.el-tabs__nav-wrap::after {
    height: 1px;
    /*no*/
}


#properties .el-tabs__item {
    padding-right: 5px !important;
    color: #6f7886;
}

.el-tabs__item:hover {
    color: #5562B4 !important;
    cursor: pointer;
}

#properties #tab-second {
    margin-left: 15px !important;
}

.is-active {
    color: #5562B4 !important;

}

.tip-content {
    font-size: 14px;
    /*no*/
    color: #6f7886;
    line-height: 25px;
    /*no*/
    white-space: pre-line;
    overflow: auto;
    width: 100%;
    height: 305px;
    /*no*/
}

.tip-content::-webkit-scrollbar {
    width: 5px;
    /*no*/
    height: 5px;
    /*no*/
    background-color: #fff;
}

.tip-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

#properties #tab-first,
#tab-second {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
}

#properties #tab-second {
    margin-left: 0 !important;
}


#properties .el-tabs__content{
     height: 320px !important;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding:0 !important;
}
.is-top {
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/properties_popup.vue